module.exports = __webpack_public_path__ + "static/txtling2-674x1024-bfd6c91e770c36e39726782e4991b5e2.png";